(function () {
  'use strict';

  var root = document.querySelector('[data-ai-chat]');
  if (!root) return;

  var proxyUrl = root.getAttribute('data-proxy-url');
  var designUrl = root.getAttribute('data-design-url') || '';
  var orderUrl = root.getAttribute('data-order-url') || '';
  var toggle = root.querySelector('[data-ai-chat-toggle]');
  var panel = root.querySelector('[data-ai-chat-panel]');
  var closeBtn = root.querySelector('[data-ai-chat-close]');
  var messagesEl = root.querySelector('[data-ai-chat-messages]');
  var form = root.querySelector('[data-ai-chat-form]');
  var input = root.querySelector('[data-ai-chat-input]');
  var sendBtn = root.querySelector('[data-ai-chat-send]');

  var history = [];
  var isSending = false;

  function setOpen(open) {
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    root.classList.toggle('is-open', open);
    if (open) {
      window.requestAnimationFrame(function () {
        input.focus();
      });
    }
  }

  toggle.addEventListener('click', function () {
    setOpen(panel.hidden);
  });

  closeBtn.addEventListener('click', function () {
    setOpen(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) setOpen(false);
  });

  function scrollDown() {
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function addMessage(role, text, imageUrl) {
    var el = document.createElement('div');
    el.className = 'ai-chat__message ai-chat__message--' + role;
    if (text) {
      var textEl = document.createElement('p');
      textEl.className = 'ai-chat__message-text';
      textEl.textContent = text;
      el.appendChild(textEl);
    }
    if (imageUrl) {
      var img = document.createElement('img');
      img.className = 'ai-chat__message-image';
      img.src = imageUrl;
      img.alt = 'AI-generated design concept';
      img.loading = 'lazy';
      el.appendChild(img);
    }
    messagesEl.appendChild(el);
    scrollDown();
    return el;
  }

  function autoGrow() {
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 120) + 'px';
  }
  input.addEventListener('input', autoGrow);

  form.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
    }
  });

  if (designUrl) {
    initAssistant();
  } else {
    initBasicChat();
  }

  /* =========================================================
     Basic chat (original behavior, used when no Design URL)
     ========================================================= */
  function initBasicChat() {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (isSending) return;

      var text = input.value.trim();
      if (!text) return;

      addMessage('user', text);
      history.push({ role: 'user', content: text });
      input.value = '';
      autoGrow();

      isSending = true;
      sendBtn.disabled = true;
      var typingEl = addMessage('assistant', 'Typing…');
      typingEl.classList.add('ai-chat__message--pending');

      fetch(proxyUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages: history }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (result) {
          typingEl.remove();
          if (result.ok && result.data && result.data.reply) {
            addMessage('assistant', result.data.reply, result.data.imageUrl);
            history.push({ role: 'assistant', content: result.data.reply });
          } else {
            addMessage('assistant', (result.data && result.data.error) || "Sorry, something went wrong. Please try again in a moment.");
          }
        })
        .catch(function () {
          typingEl.remove();
          addMessage('assistant', "Sorry, I couldn't connect. Please check your connection and try again.");
        })
        .finally(function () {
          isSending = false;
          sendBtn.disabled = false;
        });
    });
  }

  /* =========================================================
     Design Assistant (ChatGPT-style, with image uploads,
     recent chats and an images gallery saved on this device)
     ========================================================= */
  function initAssistant() {
    var attachBtn = root.querySelector('[data-ai-attach]');
    var fileInput = root.querySelector('[data-ai-file]');
    var tray = root.querySelector('[data-ai-tray]');
    var trayThumbs = root.querySelector('[data-ai-tray-thumbs]');
    var consent = root.querySelector('[data-ai-consent]');
    var greetingEl = root.querySelector('[data-ai-greeting]');
    var startersEl = root.querySelector('[data-ai-starters]');
    var subheading = root.querySelector('[data-ai-subheading]');
    var defaultSub = subheading ? subheading.textContent : '';
    var drawer = root.querySelector('[data-ai-drawer]');
    var chatList = root.querySelector('[data-ai-chat-list]');
    var gallery = root.querySelector('[data-ai-gallery]');
    var drawerEmpty = root.querySelector('[data-ai-drawer-empty]');
    var tabs = root.querySelectorAll('[data-ai-tab]');
    var expandBtn = root.querySelector('[data-ai-expand]');
    var viewer = root.querySelector('[data-ai-viewer]');
    var viewerImg = root.querySelector('[data-ai-viewer-img]');
    var viewerActions = root.querySelector('[data-ai-viewer-actions]');

    var MAX_IMAGES = 3;
    var KEEP_CHATS = 50;
    var KEEP_IMAGES = 120;
    var attachments = [];
    var current = null; // { id, title, created, updated, responseId, thumb, messages: [] }
    var activeTab = 'chats';
    var blobUrls = {};

    /* ---------- Storage (IndexedDB, this device only) ---------- */
    var dbPromise = new Promise(function (resolve) {
      try {
        var req = indexedDB.open('instagarment-design-assistant', 1);
        req.onupgradeneeded = function () {
          var db = req.result;
          if (!db.objectStoreNames.contains('chats')) db.createObjectStore('chats', { keyPath: 'id' });
          if (!db.objectStoreNames.contains('images')) {
            var s = db.createObjectStore('images', { keyPath: 'id' });
            s.createIndex('created', 'created');
          }
        };
        req.onsuccess = function () { resolve(req.result); };
        req.onerror = function () { resolve(null); };
        req.onblocked = function () { resolve(null); };
      } catch (e) {
        resolve(null);
      }
    });

    function store(name, mode, work) {
      return dbPromise.then(function (db) {
        if (!db) return null;
        return new Promise(function (resolve, reject) {
          var t = db.transaction(name, mode);
          var s = t.objectStore(name);
          var result = work(s);
          t.oncomplete = function () { resolve(result && 'result' in result ? result.result : result); };
          t.onerror = function () { reject(t.error); };
          t.onabort = function () { reject(t.error); };
        });
      }).catch(function () { return null; });
    }

    function getAll(name) {
      return store(name, 'readonly', function (s) { return s.getAll(); }).then(function (r) { return r || []; });
    }
    function getOne(name, id) {
      return store(name, 'readonly', function (s) { return s.get(id); });
    }
    function putOne(name, value) {
      return store(name, 'readwrite', function (s) { s.put(value); });
    }
    function deleteOne(name, id) {
      return store(name, 'readwrite', function (s) { s.delete(id); });
    }

    function uid(prefix) {
      return prefix + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    }

    function saveImage(dataUrl, kind, chatId) {
      var rec = { id: uid('img_'), data: dataUrl, kind: kind, chatId: chatId, created: Date.now() };
      return putOne('images', rec).then(function () { return rec.id; });
    }

    function loadImages(ids) {
      return Promise.all((ids || []).map(function (id) {
        return getOne('images', id).then(function (r) { return r ? r.data : null; });
      })).then(function (list) { return list.filter(Boolean); });
    }

    function saveCurrent() {
      if (!current) return Promise.resolve();
      current.updated = Date.now();
      return putOne('chats', current).then(prune);
    }

    // Keep storage tidy: oldest chats and images go first.
    function prune() {
      return getAll('chats').then(function (chats) {
        chats.sort(function (a, b) { return b.updated - a.updated; });
        var extra = chats.slice(KEEP_CHATS);
        return Promise.all(extra.map(function (c) { return removeChat(c.id, c); }));
      }).then(function () {
        return getAll('images');
      }).then(function (imgs) {
        imgs.sort(function (a, b) { return b.created - a.created; });
        return Promise.all(imgs.slice(KEEP_IMAGES).map(function (i) { return deleteOne('images', i.id); }));
      });
    }

    function removeChat(id, chat) {
      var ids = [];
      (chat && chat.messages || []).forEach(function (m) { ids = ids.concat(m.images || []); });
      return Promise.all(ids.map(function (i) { return deleteOne('images', i); }))
        .then(function () { return deleteOne('chats', id); });
    }

    /* ---------- Helpers ---------- */
    function blobUrlFor(dataUrl) {
      if (blobUrls[dataUrl]) return Promise.resolve(blobUrls[dataUrl]);
      return fetch(dataUrl).then(function (r) { return r.blob(); }).then(function (b) {
        blobUrls[dataUrl] = URL.createObjectURL(b);
        return blobUrls[dataUrl];
      });
    }

    function actionButtons(src, extra) {
      var frag = document.createDocumentFragment();
      var dl = document.createElement('a');
      dl.className = 'ai-chat__design-btn';
      dl.textContent = 'Download';
      dl.download = 'instagarment-design.png';
      dl.href = src;
      blobUrlFor(src).then(function (u) { dl.href = u; }).catch(function () {});
      frag.appendChild(dl);
      if (orderUrl) {
        var order = document.createElement('a');
        order.href = orderUrl;
        order.className = 'ai-chat__design-btn ai-chat__design-btn--primary';
        order.textContent = 'Print it on a shirt';
        frag.appendChild(order);
      }
      if (extra) frag.appendChild(extra);
      return frag;
    }

    function relativeDate(ts) {
      var d = new Date(ts);
      var now = new Date();
      var days = Math.floor((new Date(now.toDateString()) - new Date(d.toDateString())) / 86400000);
      if (days === 0) return 'Today, ' + d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
      if (days === 1) return 'Yesterday';
      if (days < 7) return d.toLocaleDateString([], { weekday: 'long' });
      return d.toLocaleDateString([], { month: 'short', day: 'numeric' });
    }

    /* ---------- Rendering messages ---------- */
    function renderUserMessage(text, imageSrcs) {
      var el = addMessage('user', text);
      if (imageSrcs && imageSrcs.length) {
        var strip = document.createElement('div');
        strip.className = 'ai-chat__user-images';
        imageSrcs.forEach(function (src) {
          var im = document.createElement('img');
          im.src = src;
          im.alt = 'Your image';
          strip.appendChild(im);
        });
        el.insertBefore(strip, el.firstChild);
      }
      return el;
    }

    function renderAssistantMessage(text, imageSrcs, imagesLeft) {
      var el = document.createElement('div');
      el.className = 'ai-chat__message ai-chat__message--assistant' + (imageSrcs && imageSrcs.length ? ' ai-chat__designs' : '');
      if (text) {
        var p = document.createElement('p');
        p.className = 'ai-chat__message-text';
        p.textContent = text;
        el.appendChild(p);
      }
      (imageSrcs || []).forEach(function (src, i) {
        var card = document.createElement('figure');
        card.className = 'ai-chat__design';
        var view = document.createElement('button');
        view.type = 'button';
        view.className = 'ai-chat__design-view';
        view.setAttribute('aria-label', 'View design ' + (i + 1) + ' larger');
        var img = document.createElement('img');
        img.src = src;
        img.alt = 'Design ' + (i + 1);
        view.appendChild(img);
        view.addEventListener('click', function () { openViewer(src); });
        card.appendChild(view);
        var actions = document.createElement('div');
        actions.className = 'ai-chat__design-actions';
        actions.appendChild(actionButtons(src));
        card.appendChild(actions);
        el.appendChild(card);
      });
      if (imageSrcs && imageSrcs.length && typeof imagesLeft === 'number') {
        var tip = document.createElement('p');
        tip.className = 'ai-chat__design-tip';
        tip.textContent = imagesLeft + (imagesLeft === 1 ? ' design' : ' designs') + ' left today. Ask for changes anytime.';
        el.appendChild(tip);
      }
      messagesEl.appendChild(el);
      scrollDown();
      return el;
    }

    function resetMessages(showStarters) {
      messagesEl.innerHTML = '';
      if (greetingEl) messagesEl.appendChild(greetingEl);
      if (showStarters && startersEl) messagesEl.appendChild(startersEl);
    }

    function setSubheading(text) {
      if (subheading) subheading.textContent = text || defaultSub;
    }

    /* ---------- Chats ---------- */
    function newChat() {
      if (isSending) return;
      current = null;
      attachments = [];
      renderTray();
      resetMessages(true);
      setSubheading('');
      closeDrawer();
      refreshDrawer();
      input.value = '';
      autoGrow();
      input.focus();
    }

    function openChat(id) {
      if (isSending) return;
      getOne('chats', id).then(function (chat) {
        if (!chat) return;
        current = chat;
        resetMessages(false);
        setSubheading(chat.title);
        var chain = Promise.resolve();
        chat.messages.forEach(function (m) {
          chain = chain.then(function () {
            return loadImages(m.images).then(function (srcs) {
              if (m.role === 'user') renderUserMessage(m.text, srcs);
              else renderAssistantMessage(m.text, srcs);
            });
          });
        });
        return chain.then(function () {
          closeDrawer();
          refreshDrawer();
          scrollDown();
        });
      });
    }

    function refreshDrawer() {
      if (!drawer) return;
      dbPromise.then(function (db) {
        if (!db) {
          chatList.innerHTML = '';
          gallery.innerHTML = '';
          drawerEmpty.hidden = false;
          drawerEmpty.textContent = "History can't be saved in this browser (private browsing may be on).";
          return;
        }
        if (activeTab === 'chats') renderChatList();
        else renderGallery();
      });
    }

    function renderChatList() {
      getAll('chats').then(function (chats) {
        chats.sort(function (a, b) { return b.updated - a.updated; });
        chatList.innerHTML = '';
        drawerEmpty.hidden = chats.length > 0;
        drawerEmpty.textContent = 'Your design chats will show up here.';
        var thumbJobs = [];
        chats.forEach(function (chat) {
          var li = document.createElement('li');
          li.className = 'ai-chat__chat-item' + (current && current.id === chat.id ? ' is-current' : '');

          var open = document.createElement('button');
          open.type = 'button';
          open.className = 'ai-chat__chat-open';
          var thumb;
          if (chat.thumb) {
            thumb = document.createElement('img');
            thumb.className = 'ai-chat__chat-thumb';
            thumb.alt = '';
            thumbJobs.push(getOne('images', chat.thumb).then(function (r) { if (r) thumb.src = r.data; }));
          } else {
            thumb = document.createElement('span');
            thumb.className = 'ai-chat__chat-thumb ai-chat__chat-thumb--empty';
            thumb.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>';
          }
          var textWrap = document.createElement('span');
          textWrap.className = 'ai-chat__chat-text';
          var t = document.createElement('span');
          t.className = 'ai-chat__chat-title';
          t.textContent = chat.title || 'Design chat';
          var d = document.createElement('span');
          d.className = 'ai-chat__chat-date';
          d.textContent = relativeDate(chat.updated);
          textWrap.appendChild(t);
          textWrap.appendChild(d);
          open.appendChild(thumb);
          open.appendChild(textWrap);
          open.addEventListener('click', function () { openChat(chat.id); });

          var del = document.createElement('button');
          del.type = 'button';
          del.className = 'ai-chat__chat-delete';
          del.setAttribute('aria-label', 'Delete chat');
          var trash = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14"/></svg>';
          del.innerHTML = trash;
          var confirmTimer;
          del.addEventListener('click', function () {
            if (!del.classList.contains('is-confirming')) {
              del.classList.add('is-confirming');
              del.textContent = 'Delete';
              confirmTimer = setTimeout(function () {
                del.classList.remove('is-confirming');
                del.innerHTML = trash;
              }, 3000);
              return;
            }
            clearTimeout(confirmTimer);
            removeChat(chat.id, chat).then(function () {
              if (current && current.id === chat.id) newChat();
              else refreshDrawer();
            });
          });

          li.appendChild(open);
          li.appendChild(del);
          chatList.appendChild(li);
        });
      });
    }

    function renderGallery() {
      getAll('images').then(function (imgs) {
        imgs = imgs.filter(function (i) { return i.kind === 'design'; });
        imgs.sort(function (a, b) { return b.created - a.created; });
        gallery.innerHTML = '';
        drawerEmpty.hidden = imgs.length > 0;
        drawerEmpty.textContent = 'Designs you make will collect here.';
        imgs.forEach(function (rec) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ai-chat__gallery-item';
          b.setAttribute('aria-label', 'Open design from ' + relativeDate(rec.created));
          var im = document.createElement('img');
          im.src = rec.data;
          im.alt = '';
          im.loading = 'lazy';
          b.appendChild(im);
          b.addEventListener('click', function () { openViewer(rec.data, rec.chatId); });
          gallery.appendChild(b);
        });
      });
    }

    function setTab(name) {
      activeTab = name;
      Array.prototype.forEach.call(tabs, function (t) {
        t.setAttribute('aria-selected', t.getAttribute('data-ai-tab') === name ? 'true' : 'false');
      });
      chatList.hidden = name !== 'chats';
      gallery.hidden = name !== 'images';
      refreshDrawer();
    }

    Array.prototype.forEach.call(tabs, function (t) {
      t.addEventListener('click', function () { setTab(t.getAttribute('data-ai-tab')); });
    });

    /* ---------- Drawer, full screen, viewer ---------- */
    function sidebarIsPinned() {
      return root.classList.contains('is-expanded') && window.matchMedia('(min-width: 900px)').matches;
    }

    function openDrawer() {
      root.classList.add('is-drawer-open');
      refreshDrawer();
    }

    function closeDrawer() {
      root.classList.remove('is-drawer-open');
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-ai-drawer-open]'), function (b) {
      b.addEventListener('click', openDrawer);
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-ai-drawer-close], [data-ai-scrim]'), function (b) {
      b.addEventListener('click', closeDrawer);
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-ai-new]'), function (b) {
      b.addEventListener('click', newChat);
    });

    function setExpanded(on) {
      root.classList.toggle('is-expanded', on);
      expandBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      expandBtn.setAttribute('aria-label', on ? 'Exit full screen' : 'Expand chat');
      document.documentElement.style.overflow = on ? 'hidden' : '';
      if (on) refreshDrawer();
      scrollDown();
    }

    if (expandBtn) {
      expandBtn.addEventListener('click', function () {
        setExpanded(!root.classList.contains('is-expanded'));
      });
    }

    closeBtn.addEventListener('click', function () {
      if (root.classList.contains('is-expanded')) setExpanded(false);
      closeDrawer();
    });

    function openViewer(src, chatId) {
      viewerImg.src = src;
      viewerActions.innerHTML = '';
      var extra = null;
      if (chatId && (!current || current.id !== chatId)) {
        extra = document.createElement('button');
        extra.type = 'button';
        extra.className = 'ai-chat__design-btn';
        extra.textContent = 'Open chat';
        extra.addEventListener('click', function () {
          closeViewer();
          openChat(chatId);
        });
      }
      viewerActions.appendChild(actionButtons(src, extra));
      viewer.hidden = false;
      viewer.querySelector('[data-ai-viewer-close]').focus();
    }

    function closeViewer() {
      viewer.hidden = true;
      viewerImg.removeAttribute('src');
    }

    viewer.querySelector('[data-ai-viewer-close]').addEventListener('click', closeViewer);
    viewer.addEventListener('click', function (e) {
      if (e.target === viewer) closeViewer();
    });

    // Escape closes the innermost layer first.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || panel.hidden) return;
      if (!viewer.hidden) {
        closeViewer();
      } else if (root.classList.contains('is-drawer-open') && !sidebarIsPinned()) {
        closeDrawer();
      } else if (root.classList.contains('is-expanded')) {
        setExpanded(false);
      } else {
        return;
      }
      e.stopPropagation();
    }, true);

    /* ---------- Starters ---------- */
    if (startersEl) {
      Array.prototype.forEach.call(startersEl.querySelectorAll('[data-ai-starter]'), function (btn) {
        btn.addEventListener('click', function () {
          input.value = btn.getAttribute('data-ai-starter');
          autoGrow();
          input.focus();
          input.setSelectionRange(input.value.length, input.value.length);
          if (btn.hasAttribute('data-ai-starter-attach')) fileInput.click();
        });
      });
    }

    /* ---------- Attachments ---------- */
    // Shrink big phone photos before upload so they send fast.
    function prepareImage(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onerror = reject;
        reader.onload = function () {
          var img = new Image();
          img.onerror = function () { reject(new Error('unreadable')); };
          img.onload = function () {
            var max = 1536;
            var scale = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
            var w = Math.round(img.naturalWidth * scale);
            var h = Math.round(img.naturalHeight * scale);
            var canvas = document.createElement('canvas');
            canvas.width = w;
            canvas.height = h;
            canvas.getContext('2d').drawImage(img, 0, 0, w, h);
            var keepAlpha = file.type === 'image/png';
            resolve(canvas.toDataURL(keepAlpha ? 'image/png' : 'image/jpeg', 0.88));
          };
          img.src = reader.result;
        };
        reader.readAsDataURL(file);
      });
    }

    function renderTray() {
      trayThumbs.innerHTML = '';
      attachments.forEach(function (src, i) {
        var wrap = document.createElement('div');
        wrap.className = 'ai-chat__tray-item';
        var img = document.createElement('img');
        img.src = src;
        img.alt = 'Attached image ' + (i + 1);
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'ai-chat__tray-remove';
        x.setAttribute('aria-label', 'Remove image ' + (i + 1));
        x.textContent = '×';
        x.addEventListener('click', function () {
          attachments.splice(i, 1);
          renderTray();
        });
        wrap.appendChild(img);
        wrap.appendChild(x);
        trayThumbs.appendChild(wrap);
      });
      tray.hidden = attachments.length === 0;
      if (!attachments.length) consent.checked = false;
      attachBtn.disabled = attachments.length >= MAX_IMAGES;
    }

    attachBtn.addEventListener('click', function () { fileInput.click(); });
    fileInput.addEventListener('change', function () {
      var files = Array.prototype.slice.call(fileInput.files || []);
      fileInput.value = '';
      var room = MAX_IMAGES - attachments.length;
      if (files.length > room) addMessage('assistant', 'You can attach up to ' + MAX_IMAGES + ' images at a time.');
      files.slice(0, room).forEach(function (f) {
        if (f.size > 25 * 1024 * 1024) {
          addMessage('assistant', f.name + ' is too large. Please choose an image under 25 MB.');
          return;
        }
        prepareImage(f).then(function (src) {
          attachments.push(src);
          renderTray();
        }).catch(function () {
          addMessage('assistant', "I couldn't open " + f.name + '. Try a JPG or PNG.');
        });
      });
    });

    /* ---------- Sending ---------- */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (isSending) return;

      var text = input.value.trim();
      if (!text && !attachments.length) return;
      if (attachments.length && !consent.checked) {
        addMessage('assistant', 'Please tick the box confirming you have permission to use these images, then send again.');
        return;
      }

      if (startersEl && startersEl.parentNode) startersEl.parentNode.removeChild(startersEl);

      if (!current) {
        current = {
          id: uid('chat_'),
          title: (text || 'Image design').slice(0, 60),
          created: Date.now(),
          updated: Date.now(),
          responseId: null,
          thumb: null,
          messages: [],
        };
        setSubheading(current.title);
      }
      var chat = current;
      var uploads = attachments.slice();
      renderUserMessage(text, uploads);

      var sending = {
        message: text,
        images: uploads,
        consent: consent.checked,
        previousResponseId: chat.responseId,
      };
      attachments = [];
      renderTray();
      input.value = '';
      autoGrow();

      Promise.all(uploads.map(function (src) { return saveImage(src, 'upload', chat.id); }))
        .then(function (ids) {
          chat.messages.push({ role: 'user', text: text, images: ids.filter(Boolean) });
          return saveCurrent();
        })
        .then(refreshDrawer);

      isSending = true;
      sendBtn.disabled = true;
      var pending = addMessage('assistant', 'Thinking…');
      pending.classList.add('ai-chat__message--pending');
      var slowTimer = setTimeout(function () {
        var t = pending.querySelector('.ai-chat__message-text');
        if (t) t.textContent = 'Working on your design… this can take up to a minute.';
      }, 6000);

      fetch(designUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(sending),
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (result) {
          pending.remove();
          if (!(result.ok && result.data)) {
            addMessage('assistant', (result.data && result.data.error) || 'Sorry, something went wrong. Please try again.');
            return;
          }
          var data = result.data;
          var stillHere = current && current.id === chat.id;
          if (stillHere) renderAssistantMessage(data.reply, data.images, data.imagesLeft);
          if (data.responseId) chat.responseId = data.responseId;
          return Promise.all((data.images || []).map(function (src) { return saveImage(src, 'design', chat.id); }))
            .then(function (ids) {
              ids = ids.filter(Boolean);
              if (ids.length) chat.thumb = ids[ids.length - 1];
              chat.messages.push({ role: 'assistant', text: data.reply || '', images: ids });
              if (stillHere) return saveCurrent();
              chat.updated = Date.now();
              return putOne('chats', chat);
            })
            .then(refreshDrawer);
        })
        .catch(function () {
          pending.remove();
          addMessage('assistant', "Sorry, I couldn't connect. Please check your connection and try again.");
        })
        .finally(function () {
          clearTimeout(slowTimer);
          isSending = false;
          sendBtn.disabled = false;
        });
    });

    refreshDrawer();
  }
})();
